import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import Nav from '../components/nav';
import { withStyles, CssBaseline} from '@material-ui/core';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
const theme = createMuiTheme({
    palette: {
        primary: {main: '#490e6f'}
    }
  });
const styles = (theme:any) => ({
    palette: {
        secondary: {
          main: '#E33E7F'
        }
      },
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto'
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4)
    },
    appBarSpacer: theme.mixins.toolbar
});
interface Props {
    classes: any;
}
class Admin extends Component<Props> {
    
   public render(){    
       const {classes} = this.props; 
        return(
            <MuiThemeProvider theme={theme}>
                <CssBaseline />
                <Nav />
                <main className={classes.content}>
                    <div className={classes.appBarSpacer} />
                    {this.props.children}                    
                </main>
                </MuiThemeProvider>
        );
    }
}
export default withRouter(withStyles(styles)(Admin) as any);